import React from 'react'
import { useState } from 'react'
import { ReactComponent as SendIcon} from '../../../../images/icons/send.svg'

const Input = ({openChatBox,connection}) => {
    const [message, setMessage] = useState('');
    const User = JSON.parse(localStorage.getItem("user-info"));
    const send = (async ()=>{
        try {
            if(message != ""){
                await connection.invoke("SendMessage", {jwt:User.token,message:{
                    message: message,
                    product: 0,
                    userid: parseInt(User.id),
                    room: parseInt(openChatBox.id),
                    isRead: false
                }});
                setMessage('');
            }
          } catch (e) {
            console.log(e);
          }
    })
    const handleKeyPress = (event) => {
        if(event.key === 'Enter'){
            send()
        }
    }
  return (
    <div className='open_chatbox_input'>
        <input 
            type={'text'}
            placeholder={'Enter your message'} 
            value={message} 
            onChange={(e)=>setMessage(e.target.value)}
            onKeyPress={handleKeyPress}
        />
        <button onClick={()=>{
            send();
        }}><SendIcon /></button>
    </div>
  )
}

export default Input
